import Vue from 'vue';
import Vuex from 'vuex';

import app from './modules/app';
import user from '@videotools/js/store/modules/user';
import userModule, { mutations as sharedUserMutations } from '@shared/js/store/modules/user';
import event from './modules/event';
import tags from './modules/tags';
import features from './modules/features';
import sync from './modules/sync';
import device from '@shared/js/store/modules/device';
import featureTokens from '@shared/js/store/modules/featureTokens';
import player from './modules/player';
import videos from './modules/videos';
import eventTagEdit from './modules/event-tag-edit';
import clipFilters from './modules/clip-filters';
import tagGroups from './modules/tag-groups';
import error from './modules/error';
import tagCenter from './modules/tag-center';
import permissions from './modules/permissions';
import markingZone from '@videotools/js/store/modules/marking-zone';
import clipLikes from './modules/clip-like';
import scoreboardControl from '@videotools/js/store/modules/scoreboard-control';
import videoCreate from '@videotools/js/store/modules/video-create';
import timelineTags from '@videotools/js/store/modules/timeline-tags';
import playerUi from '@videotools/js/store/modules/player-ui.js';
import highlights from '@videotools/js/store/modules/highlights';
import highlightTool from '@videotools/js/store/modules/highlight-tool';
Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		app,
		user,
		sharedUser:         userModule,
		event,
		tags,
		features,
		sync,
		device,
		featureTokens,
		player,
		videos,
		eventTagEdit,
		clipFilters,
		tagFilters:         clipFilters,
		athleteTagFilters:  clipFilters,
		athleteClipFilters: clipFilters,
		error,
		tagGroups,
		tagCenter,
		permissions,
		markingZone,
		clipLikes,
		scoreboardControl,
		timelineTags,
		playerUi,
		videoCreate,
		highlights,
		highlightTool,
	},
});

store.dispatch('device/init');
store.dispatch('featureTokens/init');
store.dispatch('player/init');

// Sync no-spoiler mode when toggled in arena header (same page, embedded player)
window.addEventListener('noSpoilerModeChanged', (e) => {
	store.commit(`sharedUser/${sharedUserMutations.SET_NO_SPOILER_MODE}`, e.detail.value);
});

export default store;
